export default __webpack_public_path__ + "static/media/clairvoyix-image.3405bfb6.gif";